require('../../fhApp/currentUser/currentUser');
require('../../shared/gameInfo/gameInfoDirective');

"use strict";

angular.module('app.gamesOfTheWeek.gameCard.gameCardController', [
    'app.currentUser',
    'app.shared.gameInfo.gameInfoDirective'
])
.controller('app.gamesOfTheWeek.gameCard.gameCardController', [
    '$scope', 'currentUser', '$state',
    function ($scope, currentUser, $state) {
        $scope.game = $scope.game || null;
        $scope.currentUser = currentUser;

        $scope.clicked = function () {
            if(currentUser.is_logged_in() && $scope.game.can_play){
                $state.go('app.play', {type: 'game', id: $scope.game.igameid});
            } else if (currentUser.is_logged_in() && !$scope.game.can_play) {
                $state.go('app.pricing', null, {inherit: false, reload: true});
            } else {
                $state.go('app.login');
            }
        }
    }
]);


// WEBPACK FOOTER //
// ./app.v2/components/gamesOfTheWeek/gameCard/gameCardController.js